export const experience = [
  {
    title: "19th April 2021",
    cardTitle: "Became 3* on codechef",
  },
  {
    title: "1st Febuarary 2022",
    cardTitle: "First open source event",
    media: {
      type: "IMAGE",
      source: {
        url: "https://dakshgupta2002.github.io/jwoc.png"
      }
    }
  },
  {
    title: "2nd March 2022",
    cardTitle: "Full stack remote intern",
    media: {
      type: "IMAGE",
      source: {
        url: "https://dakshgupta2002.github.io/fanfury.png"
      }
    }
  },

  {
    title: "May 2022",
    cardTitle: "Won IEEE Hackadroit",

  },
  {
    title: "10th August 2022",
    cardTitle: "Hackon Amazon Grand Finale",
    url: "https://www.linkedin.com/feed/update/urn:li:activity:6963786949245456386/",
    media: {
      source: {
        url: "https://www.youtube.com/embed/Ftpi5qaLBrE",
        type: "mp4"
      },
      type: "VIDEO",
      name: "Augine"
    }
  },
  {
    title: "28th October 2022",
    cardTitle: "CHD Police - Infosys Hackathon",
    url: "https://www.linkedin.com/feed/update/urn:li:activity:6993268144932839424/",
    media: {
      source: {
        url: "https://www.youtube.com/embed/GbZLtqTGYDk",
        type: "mp4"
      },
      type: "VIDEO",
      name: "ChanPol"
    }
  },
  {
    title: "24th November 2022",
    cardTitle: "Code Blooded 4.0",
    url: "https://www.linkedin.com/posts/dakshgupta1511_congratulations-to-all-the-winners-of-hackathon-activity-7002621051465551872-U7ys/?utm_source=share&utm_medium=member_desktop",
    media: {
      source: {
        url: "https://www.youtube.com/embed/cjmt4q1irAQ",
        type: "mp4"
      },
      type: "VIDEO",
      name: "Fast Vibe"
    }
  }

];